import * as React from "react";
import { styled } from "theme";
import { Button } from "@chakra-ui/core";

import { motion } from "framer-motion";

export interface Props {
  price: number;
}

export default function Control({ price }: Props) {
  const [loading, setLoading] = React.useState(false);
  const submitCart = () => {
    //@ts-ignore
    if (window.Checkout) {
      //@ts-ignore
      window.Checkout("cart");
    }
    setLoading(true);
  };

  let btw = 1.2;
  let priceExcl = price / btw;
  let priceBtw = price - priceExcl;

  return (
    <ControlContainer
      initial={{
        translateX: "100%"
      }}
      animate={{
        translateX: 0
      }}
      exit={{
        translateX: "100%"
      }}
    >
      <PriceInfo className="sub">
        <label>exclusief</label>
        <p>€{priceExcl.toFixed(2)}</p>
      </PriceInfo>
      <PriceInfo className="sub">
        <label>btw</label>
        <p>€{priceBtw.toFixed(2)}</p>
      </PriceInfo>
      <PriceInfo>
        <label>Totaal</label>
        <p>€{price}</p>
      </PriceInfo>

      <CTA>
        <Button variantColor="green" isLoading={loading} onClick={submitCart}>
          Bestellen
        </Button>
      </CTA>
    </ControlContainer>
  );
}

const _ControlContainer = styled.div`
  position: absolute;
  left: 40%;
  top: 70%;
  width: 60%;
  height: 30%;

  background-color: #322f2a;

  display: flex;
  align-items: center;
  justify-content: space-around;
  color: #fff;
  padding: 0 64px;

  @media (max-width: 768px) {
    left: 0;
    top: 90%;
    height: 10%;
    width: 100%;
    padding: 0 8px;
  }
`;

const ControlContainer = motion.custom(_ControlContainer);

const CTA = styled.div``;

const PriceInfo = styled.div`
  label {
    font-size: 12px;
    opacity: 0.7;
  }
  p {
    font-weight: bold;
    font-size: 18px;
  }

  &.sub {
    opacity: 0.4;
  }

  @media (max-width: 768px) {
    label {
      font-size: 11px;
      opacity: 0.7;
    }
    p {
      font-weight: bold;
      font-size: 14px;
    }
  }
`;
